'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formSubmissionFailed = undefined;

var _formConstants = require('./formConstants');

var formSubmissionFailed = exports.formSubmissionFailed = function formSubmissionFailed(_ref) {
    var form = _ref.form,
        primaryError = _ref.primaryError,
        _ref$reportError = _ref.reportError,
        reportError = _ref$reportError === undefined ? true : _ref$reportError;
    return {
        type: _formConstants.FORM_SUBMISSION_FAILED,
        form: form,
        primaryError: primaryError,
        reportError: reportError
    };
}; // Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/formActions.js
// module id = 434
// module chunks = 0